/**
 * @generated SignedSource<<75ea973bd2d866780b41099449b45e60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateFixedPriceLockInput = {
  id: string;
  amount?: string | null;
  locked?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateFixedPriceLockMutation$variables = {
  input: UpdateFixedPriceLockInput;
};
export type updateFixedPriceLockMutation$data = {
  readonly updateFixedPriceLock: {
    readonly fixedPriceLock: {
      readonly id: string;
      readonly locked: boolean | null;
      readonly actualRevenueProjectCurrency: number | null;
      readonly progress: number | null;
    } | null;
  } | null;
};
export type updateFixedPriceLockMutation = {
  variables: updateFixedPriceLockMutation$variables;
  response: updateFixedPriceLockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateFixedPriceLockPayload",
    "kind": "LinkedField",
    "name": "updateFixedPriceLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectFixedPriceLockType",
        "kind": "LinkedField",
        "name": "fixedPriceLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualRevenueProjectCurrency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateFixedPriceLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateFixedPriceLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1b5a418bcbaae180792ebc203f792674",
    "id": null,
    "metadata": {},
    "name": "updateFixedPriceLockMutation",
    "operationKind": "mutation",
    "text": "mutation updateFixedPriceLockMutation(\n  $input: UpdateFixedPriceLockInput!\n) {\n  updateFixedPriceLock(input: $input) {\n    fixedPriceLock {\n      id\n      locked\n      actualRevenueProjectCurrency\n      progress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9896fdbe7c13396e7068baca1d658944";

export default node;
